import React, { useState } from "react";
import { RxCross2 } from "react-icons/rx";
import { BsCalendar2Date } from "react-icons/bs";
import { FaCheck } from "react-icons/fa";
const fields = [
  { label: "Relative Date", value: "RelativeDate" },
  { label: "Range Of Date", value: "RangeOfDate" },
  { label: "Years", value: "Years" },
  { label: "Financial Year", value: "Financial Year" },
  { label: "Quarter", value: "Quarter" },
  { label: "Month-year", value: "Month-year" },
  { label: "Month", value: "Month" },
  { label: "Week", value: "Week" },
  { label: "Weekday", value: "Weekday" },
  { label: "Date (date-month-year)", value: "Date (date-month-year)" },
  { label: "Date (month-date-year)", value: "Date (month-date-year)" },
];
export default function FilterFieldComp({
  settingFunction,
  setFilterFieldModal,
  droppedItem,
}) {
  const [state, setState] = useState(null);
  console.log(state);

  const handleOk = () => {
    if (state) {
      settingFunction(state, droppedItem);
    }
    if (state === "RelativeDate") {
      console.log("DateConfigComp");
    } else {
      console.log("FilterConfigComp");
    }
  };
  const { rename } = droppedItem;
  const handleKeyDown = (event) => {
    if (event.ctrlKey && event.key === "Enter") {
      handleOk();
      setFilterFieldModal(false);
    }
  };
  return (
    <main
      className="fixed inset-0 bg-gray-600 bg-opacity-50 flex flex-col items-center justify-center z-50"
      onKeyDown={handleKeyDown}
    >
      <section className="bg-white rounded shadow-md w-[22rem] h-auto flex flex-col items-center justify-start gap-1">
        {/* header  */}
        <header className="w-full flex items-center justify-between  font-medium  gap-1 p-1 bg-gray-50">
          Filter Field
          <RxCross2
            className="cursor-pointer text-black"
            onClick={() => setFilterFieldModal(false)}
          />
        </header>
        <p className="text-left w-full px-1 h-[6%]">
          How do you want to filter ({rename})
        </p>
        {/* first body */}
        <section className="border w-[97%] flex flex-col items-center justify-start mx-1">
          {fields.map((field, index) => (
            <button
              className={`p-1 flex w-full items-center justify-between gap-1 hover:bg-gray-100 ${state === field.value ? "bg-gray-100" : null
                }`}
              key={index}
              onClick={() => setState(field.value)}
            >
              <span className="flex items-center justify-start gap-1">
                <BsCalendar2Date className="text-teal-500" /> {field.label}
              </span>
              {state === field.value ? (
                <FaCheck className="text-black" />
              ) : null}
            </button>
          ))}
        </section>
        {/* footer */}
        <footer className="flex w-full items-center justify-end gap-4 p-1 bg-gray-50">
          <button
            className="border px-4 py-1"
            onClick={() => setFilterFieldModal(false)}
          >
            Cancel
          </button>
          <button
            className={`border px-4 py-1 text-center text-white ${state === null ? "bg-gray-400" : "bg-blue-950"
              }`}
            onClick={() => {
              handleOk();
              setFilterFieldModal(false);
            }}
            disabled={state === null}
          >
            {state === "RelativeDate" ? "Next" : "Ok"}
          </button>
        </footer>
      </section>
    </main>
  );
}
